<template>
	<div>
		<div class="h3 ftw600">
			<!-- 學習報告 -->
			{{$t('common.studyReport')}}
		</div>
		<a-spin :spinning="loading">
			<div class="bg-w p-4 mt-3" v-if="!showClassDetails && !showprogressDetails">
				<div class="flex around pb-3 border-b  ">
					<div style="width: 20%;">
						{{$t('appointment.teacher')}}
					</div>
					<div style="width: 15%;">
						{{$t('cashDesk.subject')}}
					</div>
					<div style="width: 15%;">
						{{$t('cashDesk.category')}}
					</div>
					<div style="width: 15%;">
						{{$t('studentsCom.classDate')}}
					</div>
					<div style="width: 15%;">
						{{$t('common.reportType')}}
					</div>
					<div style="width: 15%;">
						{{$t('common.reportDate')}}
					</div>
					<div style="width: 15%;"></div>
				</div>
				<div class="flex around pb-3 pt-3 border-bottom " v-for="(item,index) in list">
					<div class="flex alcenter" style="justify-content: flex-start;width: 20%">
						<img :src="item.teacher_photo||item.teacher_photo_image" alt="" class="photo-40" style="border-radius: 2px;" />
						<span class="ml10 ftr-1-25 text-underline" >{{item.teacher_name}}{{item.teacher_surname}}</span>
					</div>
					<div class="flex alcenter" style="width: 15%;">
						{{item.course_name}}
					</div>
					<div class="flex alcenter" style="width: 15%;">
						{{item.is_experience==1?'試堂' :'正式課'}}
					</div>
					<div class="flex alcenter" style="width: 15%;">
						{{ convertToTimeZone(item.updatetime).formattedTime }}
					</div>
					<div class="flex alcenter" style="width: 15%;">
						{{item.type==1?$t('common.classReport'):$t('common.progressReport')}}
					</div>
					<div class="flex alcenter" style="width: 15%;">
						{{ convertToTimeZone(item.updatetime).formattedTime }}
					</div>
					<div class="flex around alcenter" style="width: 15%;">
						<div class="cl-theme text-underline clickAct" @click="item.type==1?toClassDetails(item):toProgress(item)">{{$t('common.reportDetails')}}</div>
						<!-- <div class="cl-info text-underline clickAct">{{$t('common.delete')}}</div>
						<div style="width: 8px;height: 8px;background-color: red;border-radius: 50%;"></div> -->
					</div>
				</div>
			</div>
		</a-spin>
		
		<!-- 课堂报告详情 -->
		<div v-if="showClassDetails">
			<div class="bg-w p-4 mt-3 p-3 flex alcenter">
				<img :src="classInfo.teacher_photo" alt="" class="photo-50" style="border-radius: 2px;" />
				<div class="flex around" style="flex: 1;">
					<div class="text-center" style="width: 20%;">
						<div>{{$t('appointment.teacher')}}</div>
						<div class="flex mt-2 center">
							<div class="text-underline">{{classInfo.teacher_name}}{{classInfo.teacher_surname}}</div>
							<img src="../../../assets/image/staduents/report-message.png" style="width: 24px;"
							 alt="" class="ml10" @click="openKefu(classInfo.user_id)" />
						</div>
					</div>
					<div class="text-center" style="width: 10%;">
						<div>{{$t('cashDesk.subject')}}</div>
						<div class="mt-2">
							{{classInfo.course_name}}
						</div>
					</div>
					<div class="text-center" style="width: 10%;">
						<div>{{$t('studentsCom.classDate')}}</div>
						<div class="mt-2">
							{{classInfo.start_time.substring(0,10)}}
						</div>
					</div>
					<div class="text-center" style="width: 10%;">
						<div>{{$t('common.remainingClasses')}}</div>
						<div class="mt-2">
							{{classInfo.residue_quantity}}
						</div>
					</div>
					<div class="text-center" style="width: 10%;">
						<div>{{$t('common.unbookedClassroom')}}</div>
						<div class="mt-2">
							{{classInfo.quantity}}
						</div>
					</div>
					<div class="">
						<div class="mt-3">
							<img src="../../../assets/image/staduents/report-appointment.png" alt="" @click="toAppointment()" 
							v-if="Number(classInfo.residue_quantity)>0" />
							<img src="../../../assets/image/staduents/report-buy.png" @click="toTeacher()" alt="" class="ml10" />
						</div>
					</div>
				</div>
			</div>
			
			<div class="bg-w p-3 mt-3">
				<!-- <div class="ftr-1-25 ftw600">
					{{$t('common.memberClassReport',{name:'Danny'}) }}
				</div> -->
				<div class="mt-3 cl-theme ftw600">
					{{$t('studentsCom.keyLesson') }}
				</div>
				<div class="mt-2">
					<span class="ftw600">{{$t('studentsCom.researchTopic')}}:</span>
					{{reportDetailInfo.name}}
				</div>
				<div class="mt-2">
					<span class="ftw600">{{$t('studentsCom.keyLearningPoints')}}:</span>
					{{reportDetailInfo.learning_focus}}
				</div>
				<div class="mt-3 cl-theme ftw600">
					{{$t('studentsCom.studentPerformance') }}
				</div>
				<div class="flex mt-2">
					 <a-progress type="circle" :strokeWidth="10" :percent="Number(reportDetailInfo.score_concentration)"
					  :strokeColor="getColor(getScore(reportDetailInfo.score_concentration))" 
					 :format="() =>getScore(reportDetailInfo.score_concentration) +'\n'+$t('teacherIndex.classroomReport5')" />
					 
					 <a-progress type="circle" class="ml40" :strokeWidth="10" :percent="Number(reportDetailInfo.score_degree_mastery)"
					  :strokeColor="getColor(getScore(reportDetailInfo.score_degree_mastery))" 
					 :format="() =>getScore(reportDetailInfo.score_degree_mastery) +'\n'+$t('teacherIndex.classroomReport6')" />
					 
					 <a-progress type="circle" class="ml40" :strokeWidth="10" :percent="Number(reportDetailInfo.score_degree_participation)"
					  :strokeColor="getColor(getScore(reportDetailInfo.score_degree_participation))" 
					 :format="() =>getScore(reportDetailInfo.score_degree_participation) +'\n'+$t('teacherIndex.classroomReport7')" />
				</div>
				<div class="flex mt-2">
					 <a-progress type="circle" :strokeWidth="10" :percent="Number(reportDetailInfo.score_range_advancement)"
					  :strokeColor="getColor(getScore(reportDetailInfo.score_range_advancement))" 
					 :format="() =>getScore(reportDetailInfo.score_range_advancement) +'\n'+$t('teacherIndex.classroomReport8')" />
					 
					 <a-progress type="circle" class="ml40" :strokeWidth="10" :percent="Number(reportDetailInfo.score_assignment)"
					  :strokeColor="getColor(getScore(reportDetailInfo.score_assignment))" 
					 :format="() =>getScore(reportDetailInfo.score_assignment) +'\n'+$t('teacherIndex.classroomReport9')" />
					
				</div>
			</div>
			<div class="bg-w p-3 mt-3">
				<div class="cl-theme ftw600">
					{{$t('studentsCom.teacherMessage') }}
				</div>
				<div class="flex alcenter space col-md-7 col-sm-7">
					<div>
						<div class="mt-2 cl-black ftw600">
							{{$t('studentsCom.classroomHighlights') }}
						</div>
						<div>{{reportDetailInfo.class_highlights}}</div>
						<div class="mt-2 cl-black ftw600">
							{{$t('studentsCom.studySuggestions') }}
						</div>
						<div>{{reportDetailInfo.learning_advice}}</div>
						<div class="mt-2 cl-black ftw600">
							{{$t('studentsCom.nextPreview') }}
						</div>
						<div>{{reportDetailInfo.next_lesson_preview}}</div>
					</div>
					<div class="border-gray" style="width: 100px;height: 100px;text-align: center;">
						<div class="ftr-3 ftw600" :style="'color:'+getColor(getScore(reportDetailInfo.score_average)) + ';'">
							{{getScore(reportDetailInfo.score_average)}}
						</div>
						<div class="" style="margin-top: -10px;">
							{{$t('studentsCom.overallEvaluation')}}
						</div>
					</div>
				</div>
				
			</div>
			<div class="bg-w p-3 mt-3">
				<div class="cl-theme ftw600">
					{{$t('studentsCom.workOrTest') }}
				</div>
				<div class="mt-2">
					<a-checkbox-group v-model="work_testing" :disabled="true">
						<a-checkbox :value="1">{{$t('teacherConfirms.homework')}}</a-checkbox>
						<br />
						<a-checkbox :value="2">{{$t('teacherConfirms.test')}}</a-checkbox>
					</a-checkbox-group>
				</div>
			</div>
			<div class=" mt-3 flex space">
				<div class="bg-w p-3" style="height: 200px; width: 60%;">
					<div class="cl-theme ftw600">
						{{$t('studentsCom.supportYou')}} 
					</div>
					<div>
						{{reportDetailInfo.support}}
					</div>
					<div class="flex center mt-3">
						<div class="btn btn-outline-theme" @click="showClassDetails = false">
							{{$t('common.back')}}
						</div>
					</div>
				</div>
				<div class="bg-w p-3" style="height: 200px; width: 35%;">
					
				</div>
			</div>
		</div>
		<!-- 进度报告详情 -->
		<div class=" p-3" v-if="showprogressDetails">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				list:[],
				showClassDetails:false,
				showprogressDetails:false,
				classInfo:{},
				
				reportDetailInfo:{},
				work_testing:[],
				loading:false
			}
		},
		created(){
			this.reportList()
		},
		watch:{
			
			 '$route'(to, from) {
			      // console.log('路由改变了');
			      // console.log('从', from.fullPath, '到', to.fullPath);
			      // 在这里执行你想要的操作，比如数据获取、状态更新等
				  if(from.fullPath.includes('studentsProgressReport')){
					  this.showprogressDetails = false
				  }
				  // this.reportList()
			    }
		},
		methods:{
			toProgress(item){
				let obj = {
					teacher_id:item.teacher_id,
					id:item.id
				}
				this.showprogressDetails = true
				setTimeout(()=>{
					this.$router.push('/studentsProgressReport?item='+JSON.stringify(obj))
				},100)
				
			},
			getScore(score){
				if(score==''){
					return ' '
				}
				let num = Number(score)
				if(num<=50){
					return 'C-'
				}else if(num>50&&num<=55){
					return 'C'
				}else if(num>55&&num<=60){
					return 'C+'
				}else if(num>60&&num<=65){
					return 'B-'
				}else if(num>65&&num<=70){
					return 'B'
				}else if(num>70&&num<=75){
					return 'B+'
				}else if(num>75&&num<=80){
					return 'A-'
				}else if(num>80&&num<=90){
					return 'A'
				}else if(num>90){
					return 'A+'
				}
			},
			getColor(str){
				if(str.includes('A')){
					return '#52C4C9'
				}else if(str.includes('B')){
					return '#92D050'
				}else{
					return '#FFC000'
				}
			},
			reportList(){
				// this.$http.api('user/reportList',{
				// 	page:1,
				// 	limit:1000
				// }).then(res=>{
				// 	this.list = res.list
				// })
				if(this.loading) return
				this.loading = true
				this.$http.api('reservation/reportList',{
					page:1,
					limit:1000
				}).then(res=>{
					this.list = res.list
					this.list.forEach((item,index)=>{
						item.type=1
					})
					this.reportListNew()
				}).catch(err=>{
					this.loading = false
				})
			},
			reportListNew(){
				this.$http.api('user/reportListNew',{
					page:1,
					limit:1000
				}).then(res=>{
					this.loading = false
					if(res.list){
						res.list.forEach((item,index)=>{
							item.type=2
						})
						this.list = [...this.list,...res.list]
					}
					
				}).catch(err=>{
					this.loading = false
				})
			},
			
			toClassDetails(item){
				this.classInfo = item
				this.getClassDetails()
				this.showClassDetails = true
			},
			toProgressDetails(item){
				this.classInfo = item
				this.showprogressDetails = true
			},
			toTeacher(){
				this.$router.push('./teacher?id='+this.classInfo.teacher_id)
			},
			toAppointment(){
				this.$router.push('./appointment?id='+this.classInfo.user_course_package_id)
			},
			getClassDetails(){
				this.$http.api('reservation/reportDetail',{order_id:this.classInfo.reservation_order_id}).then(res=>{
					this.reportDetailInfo = res.info
					if(res.info.assignment_switch==1){
						this.work_testing.push(1)
					}
					if(res.info.testing_switch==1){
						this.work_testing.push(2)
					}
				})
			}
		}
	}
</script>

<style>
	.ant-checkbox-disabled + span {
		color: #000 !important;
	}
	.ant-checkbox-disabled .ant-checkbox-inner{
		background-color: #000 !important;
	}
	.ant-table-thead > tr > th{
		background-color: #52C4C9 !important;
		color: #fff;
	}
	.photo-50{
		width: 50px;
		height: 50px;
	}
	.icon-20{
		width:20px ;
		height: 20px;
	}
	.ant-progress-text {
	  white-space: pre-wrap !important; /* 允许换行 */
	  text-align: center !important; /* 文本居中 */
	}
</style>